import React, { useEffect, useState } from "react";
import "../styles/header.css";
import { Link } from "react-router-dom";
import logo from "../img/ankh.png";
import { useAuth } from "../context/AuthContext";
import icon from "../img/icon.png";
import axios from "../axios";

export default function Header() {
  const { currentUser, env } = useAuth();
  const [toggleNav, setToggleNav] = useState(0);
  const [onlineCount, setOnlineCount] = useState();

  useEffect(async () => {
    const result = await axios.get("/online");
    const resultCount = result.data || "";

    setOnlineCount(resultCount);
  }, []);

  const handleBurger = () => {
    console.log("handle burger");
    if (!toggleNav) {
      setToggleNav(1);
      console.log("asd");
    } else {
      setToggleNav(0);
      console.log("ggg");
    }
  };

  const handleMobileLink = () => {
    setToggleNav(0);
  };

  return (
    <div className="header">
      <div className="header__onlineCount">
        ONLINE: <span>{onlineCount}</span>
      </div>

      <div
        className={
          toggleNav === 1 ? "header__nav header__navMobile" : "header__nav"
        }
      >
        <Link to="/" className="header__navLink" onClick={handleMobileLink}>
          ANASAYFA
        </Link>
        <a
          target="_blank"
          href={env.forum}
          className="header__navLink"
          onClick={handleMobileLink}
        >
          FORUM
        </a>
        <a
          target="_blank"
          href={`${process.env.REACT_APP_URL_REHBER}`}
          className="header__navLink"
          onClick={handleMobileLink}
        >
          REHBER
        </a>
        <Link
          to="/login"
          className="header__navLink header__login"
          onClick={handleMobileLink}
        >
          {currentUser && (
            <img className="loginLogo" src={icon} alt="loginLogo"></img>
          )}
          {currentUser ? (
            <div className="currentUserOnline">{currentUser.username}</div>
          ) : (
            "HESAP"
          )}
        </Link>
        <Link
          to="/files"
          className="header__navLink"
          onClick={handleMobileLink}
        >
          DOSYALAR
        </Link>
      </div>
      <div className="logo__container">
        <img src={logo} alt="logo" />
      </div>
      <div className="header__burger" onClick={handleBurger}>
        <div className="header__burgerLine"></div>
        <div className="header__burgerLine"></div>
        <div className="header__burgerLine"></div>
      </div>
    </div>
  );
}
